import { useEffect, useMemo, useRef, useState } from "react";
import { compareStrings } from "../../../helpers/compareHelpers";
import RequestMessage from "./RequestMessage";
import RequestMessageForm from "./RequestMessageForm";
import { CPRequestDetail } from "../../../api/models/unified";

interface RequestChatProps {
  detail: CPRequestDetail;
}

const RequestChat = ({ detail }: RequestChatProps) => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [hasScrollbar, setHasScrollbar] = useState(false);

  useEffect(() => {
    const el = scrollRef.current;
    if (el) {
      el.scrollTop = el.scrollHeight;
      setHasScrollbar(el.scrollHeight > el.clientHeight);
    }
  }, [detail.messages]);

  const sortedMessages = useMemo(
    () => detail.messages.sort((a, b) => compareStrings(a.created, b.created)),
    [detail.messages],
  );

  return (
    <div>
      <div
        ref={scrollRef}
        className={`max-h-[700px] scroll-ml-1 overflow-hidden overflow-y-auto ${hasScrollbar ? "pr-2" : ""}`}
      >
        {sortedMessages.map((message) => (
          <RequestMessage key={message.id} message={message} />
        ))}
      </div>
      {(detail.state === "Open" ||
        detail.state === "WaitingForCustomerUser") && (
        <RequestMessageForm requestId={detail.id} />
      )}
    </div>
  );
};

export default RequestChat;
